import { addPence, pence, ZERO_PENCE } from '@cf/shared';
import { assertReviewed } from './review.js';
import { clampTo, excessOver, minPence, mulBps } from './bps.js';
export function stampDutyLandTax(rules, input) {
    assertReviewed(rules);
    const r = rules.sdlt;
    const price = input.purchasePrice;
    if (!Number.isSafeInteger(price) || price < 0) {
        throw new RangeError('Purchase price must be a non-negative integer of pence');
    }
    let tax = ZERO_PENCE;
    if (input.isFirstTimeBuyer && !input.isAdditionalDwelling && price <= r.ftbMaxPrice) {
        // First-time-buyer relief: nil to the FTB threshold, then the FTB rate.
        const above = excessOver(price, r.ftbNilRateBand);
        tax = mulBps(above, r.ftbRateBps);
    }
    else {
        let previousTop = ZERO_PENCE;
        for (const band of r.bands) {
            const top = band.upTo ?? price;
            const slice = clampTo(pence(minPence(price, top) - previousTop), pence(Math.max(0, price - previousTop)));
            tax = addPence(tax, mulBps(slice, band.rateBps));
            if (band.upTo === null || price <= band.upTo)
                break;
            previousTop = band.upTo;
        }
    }
    if (input.isAdditionalDwelling) {
        tax = addPence(tax, mulBps(price, r.additionalDwellingSurchargeBps));
    }
    return { taxDue: tax };
}
//# sourceMappingURL=sdlt.js.map